/* eslint-disable @typescript-eslint/no-explicit-any */
type Size = { width: number; height: number };
type Callback = (error: Error | null | undefined, size?: Size) => any;

export function getDOMSize(
  image: HTMLImageElement,
  maxWidth: number,
  maxHeight: number,
): Size {
  let outerDiv = document.createElement('div');
  Object.assign(outerDiv.style, {
    width: '0',
    height: '0',
    overflow: 'hidden',
    position: 'absolute',
  });
  let innerDiv = document.createElement('div');
  Object.assign(innerDiv.style, {
    width: maxWidth + 'px',
    height: maxHeight + 'px',
  });
  innerDiv.appendChild(image);
  outerDiv.appendChild(innerDiv);
  if (document.body) {
    document.body.appendChild(outerDiv);
  }
  let { width, height } = image;
  if (document.body) {
    document.body.removeChild(outerDiv);
  }
  return { width, height };
}

// TODO: Deprecate getImageSize in favor of loadImage
export default function getImageSize(url: string, callback: Callback) {
  let image = new Image();
  image.onload = () => {
    let { width, height } = image;
    // Workaround an issue where an SVG might have no fixed dimensions.
    if (width === 0 && height === 0) {
      ({ width, height } = getDOMSize(image, 1000, 1000));
    }
    callback(null, { width, height });
  };
  image.onerror = () => {
    callback(new Error(t('Error loading image.')));
  };
  image.src = url;
}
